import axios from '../../axios';

export const getBlobImageUrl = async (image) => {
  try {
    const blob = await fetch(image).then((r) => r.blob());
    const blobUrl = await URL.createObjectURL(blob);
    return blobUrl;
  } catch (error) {
    return error;
  }
};

export const getBase64Image = async (image) => {
  try {
    const response = await axios({
      method: 'GET',
      url: `common/assets/getbase64image?id=${image}`,
    });
    // if (!response.data.image) console.log({ image }, response);
    return `data:image/png;base64,${response.data.data}`;
  } catch (error) {
    return error;
  }
};

export const getImage = async (image) => {
  try {
    const base64Image = await getBase64Image(image);
    const imageUrl = await getBlobImageUrl(base64Image);
    return imageUrl;
  } catch (error) {
    return error;
  }
};
